
import theme from '@/config/theme';
import Vue from 'vue';
import Wrapper from './styles';

export default Vue.extend({
  name: 'Checkbox',
  components: {
    Wrapper,
  },
  props: {
    label: {
      type: String,
      default: 'Label',
    },
    name: {
      type: String,
      default: '',
    },
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
    },
    color: {
      type: String,
      default: theme.colors.primary,
    },
  },
});
